module.exports = __webpack_public_path__ + "js/stellarium-web-engine.f406ad88.wasm";